// auditSlice.ts
import { apiSlice } from '../api/apiSlice'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export type OperationType = 'addition' | 'modification' | 'deletion' | 'acknowledged' | 'unacknowledged'

export interface History {
  oldValue: string
  newValue: string
  name: string
  createdAt: string
  operationType?: OperationType
}

export interface ModificationHistoryParams {
  'chosen.id'?: string
  operationType?: OperationType
  startDate?: string
  endDate?: string
  tableName?: string
  page?: number
  size?: number
}

interface PaginatedHistory {
  content: History[]
  totalElements: number
  totalPages: number
  number: number
  size: number
}

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getModificationHistory: builder.query<History[], ModificationHistoryParams>({
      query: params => ({
        url: '/audit/history-modification',
        params,
        method: 'GET',
      }),
      transformResponse: (response: PaginatedHistory) => {
        const tz = dayjs.tz.guess()
        return response.content.map(item => ({
          ...item,
          createdAt: dayjs.utc(item.createdAt).tz(tz).format(),
        }))
      },
      providesTags: () => [{ type: 'WorkActivityHistory', id: 'LIST' }],
    }),
  }),
})

export const { useGetModificationHistoryQuery } = extendedApiSlice
